<template>
  <div class="su-container" :class="{ flex }">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'su-container',
  props: {
    flex: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="less" scoped>
.su-container {
  width: 1600px;
  margin: 0 auto;
  position: relative;
  &.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
@media (max-width: 1375px) {
  .su-container {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
  }
}

</style>
